<template>
  <div class="wrapper" :class="{'line-borders': lineBorders, 'line-center': false}">
    <div class="wrapper__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      lineBorders: {
        default: false,
      },
      lineCenter: {
        default: false,
      },
    },
  }
</script>

<style lang="scss">
  .wrapper {
    margin: 0 auto;
    width: 100%;

    @media (min-width: $media_xs) {
      max-width: 100%;
    }
    @media (min-width: $media_sm) {
      max-width: 720px;
    }
    @media (min-width: $media_md) {
      max-width: 960px;
    }
    // book;
    @media (min-width: $media_lg) {
      max-width: 1050px; //max-width: 1050px;
    }
    @media (min-width: 1370px) {
       max-width: 1200px; //max-width: 1050px;
    }
    // 4k retina imac
    @media (min-width: 2450px) {
      max-width: 1500px; //max-width: 1050px;
    }
    &.line-borders {
      border-left: 1px solid $color-blue-6;
      border-right: 1px solid $color-blue-6;
    }
    &.line-center {
      position: relative;
      &:after {
        @include pseudo;
        @include size(1px, 100%);
        background: $color-blue-6;
        top: 0;
        left: 50%;
        z-index: -1;
        pointer-events: none;
        @media(max-width: 600px) {
          display: none;
        }
      }
    }
    &__inner {
      padding: 0 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/_any/Wrapper.vue